import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nService } from '@app/i18n/services';
import { FeedbackData, FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { UsersService } from '@services/users';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { IDeleteUserDialogData } from './users-delete.models';

@Component({
	selector: 'app-users-delete',
	templateUrl: './users-delete.dialog.html'
})
export class UsersDeleteEmailDialogComponent extends OnDestroyMixin {
	constructor(
		private i18nService: I18nService,
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Inject(MAT_DIALOG_DATA) public dialogData: IDeleteUserDialogData,
		private dialogRef: MatDialogRef<UsersDeleteEmailDialogComponent>
	) {
		super();
	}

	public onFormSubmit(): void {
		const data: FeedbackData = {
			title: FeedbackTitle.warning,
			message: this.i18nService.get('Are you sure you want to delete this user?', 'app.prompt.users.delete.confirm-message'),
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) {
					this.deleteUser();
				} else {
					this.dialogRef.close();
				}
			}
		};

		this.feedbackService.confirm(data);
	}

	private deleteUser(): void {
		this.progressIndicatorService.spinner(true);

		this.usersService
			.deleteUser(
				this.dialogData.user.id,
				this.dialogData.user.email
			)
			.subscribe(
				() => {
					this.progressIndicatorService.spinner(false);
					this.dialogData.callback(null, true);
					this.feedbackService.notification({
						msg: this.i18nService.get('User deleted.', 'app.descriptor.users.user-deleted'),
						config: { duration: 4000 }
					});
					this.dialogRef.close();
				},
				(error: any) => {
					this.feedbackService.apiError(error);
					this.progressIndicatorService.spinner(false);
				}
			);
	}
}
